import { Slide } from "@jelly/lesson";

import receiver from "./components/receiver";
import source from "./components/source";
import environment from "./components/environment";

const principle: Slide = {
  title: "Sound Recording / Measurement",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Receiver" }, { name: "Source" }, { name: "Environment" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], []],
      components: [receiver, source, environment],
    },
  },
};

export default principle;
